import { UnixDuration, UnixTimestamp } from '@sparkdotfi/common-universal'

import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'

export interface CreateTxOverviewParams {
  nextEpochEnd: UnixTimestamp
  timestamp: UnixTimestamp
  formValues: TransferFromUserFormNormalizedData
}

export type TxOverview =
  | { status: 'no-overview' }
  | {
      status: 'success'
      unstakingDelay: UnixDuration
    }

export function createTxOverview({ formValues, nextEpochEnd, timestamp }: CreateTxOverviewParams): TxOverview {
  const amount = formValues.value
  if (amount.eq(0)) {
    return { status: 'no-overview' }
  }

  const unstakingDelay = getUnstakingDelay(nextEpochEnd, timestamp)

  return {
    status: 'success',
    unstakingDelay,
  }
}

function getUnstakingDelay(nextEpochEnd: UnixTimestamp, timestamp: UnixTimestamp): UnixDuration {
  if (nextEpochEnd.lt(timestamp)) {
    return UnixDuration({ seconds: 0 })
  }
  return nextEpochEnd.since(timestamp)
}
